import { UseGetUserConsents, useGetUserConsents } from "./useGetUserConsents";
import { useGetCurrentUser } from "./useGetCurrentUser";
import { UIUserStatus } from "../types/user";

type UseGetCurrentUserConsents = () => ReturnType<UseGetUserConsents>;

export const useGetCurrentUserConsents: UseGetCurrentUserConsents = () => {
  const currentUser = useGetCurrentUser();
  const consentsResponse = useGetUserConsents(currentUser);
  const isUserDeactivated =
    consentsResponse.user.status === UIUserStatus.INACTIVE;

  if (!currentUser) {
    return {
      ...consentsResponse,
      error: new Error("You are not authorized to view this page"),
    };
  }

  if (isUserDeactivated) {
    return {
      ...consentsResponse,
      error: new Error(
        "Your account has been disabled. Please contact your system administrator for assistance",
      ),
    };
  }

  return consentsResponse;
};
